import {
  IoCloseOutline,
  IoEllipsisHorizontalCircleOutline,
  IoPlayOutline,
} from "react-icons/io5";
import { defineMessage } from "react-intl";

export const CUSTOMERS_DOCUMENTS_STATES_VALUE_NOT_SENT = "not_sent";
export const CUSTOMERS_DOCUMENTS_STATES_VALUE_ACCEPTED = "accepted";
export const CUSTOMERS_DOCUMENTS_STATES_VALUE_REFUSED = "refused";
export const CUSTOMERS_DOCUMENTS_STATES_VALUE_PENDING = "pending";

export const CUSTOMERS_DOCUMENTS_STATES = {
  [CUSTOMERS_DOCUMENTS_STATES_VALUE_NOT_SENT]: {
    id: CUSTOMERS_DOCUMENTS_STATES_VALUE_NOT_SENT,
    colors: ["orange.600", "orange.300"],
    color: "orange",
    icon: IoEllipsisHorizontalCircleOutline,
    label: defineMessage({ defaultMessage: "Non envoyé" }),
  },
  [CUSTOMERS_DOCUMENTS_STATES_VALUE_PENDING]: {
    id: CUSTOMERS_DOCUMENTS_STATES_VALUE_PENDING,
    colors: ["orange.600", "orange.300"],
    color: "orange",
    icon: IoEllipsisHorizontalCircleOutline,
    label: defineMessage({ defaultMessage: "En attente de validation" }),
  },
  [CUSTOMERS_DOCUMENTS_STATES_VALUE_ACCEPTED]: {
    id: CUSTOMERS_DOCUMENTS_STATES_VALUE_ACCEPTED,
    colors: ["green.600", "green.300"],
    color: "green",
    icon: IoPlayOutline,
    label: defineMessage({ defaultMessage: "Validé" }),
  },
  [CUSTOMERS_DOCUMENTS_STATES_VALUE_REFUSED]: {
    id: CUSTOMERS_DOCUMENTS_STATES_VALUE_REFUSED,
    colors: ["red.600", "red.300"],
    color: "red",
    icon: IoCloseOutline,
    label: defineMessage({ defaultMessage: "Refusé" }),
  },
};

export const CUSTOMERS_DOCUMENTS_STATES_LIST = Object.values(
  CUSTOMERS_DOCUMENTS_STATES,
);

// ============================================================
